/**
 * Shared auth-headers helper for admin API calls.
 *
 * Source of truth: AuthContext stores the JWT in sessionStorage under the key 'admin_token'.
 * We fall back to legacy keys (localStorage 'admin_token', 'access_token', 'token') for
 * robustness across older code paths, but new code should rely on this helper only.
 */
export function getAuthToken() {
  return (
    sessionStorage.getItem('admin_token') ||
    localStorage.getItem('admin_token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('token') ||
    ''
  );
}

export function getAuthHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Build a URL to a stored file that works inside <img>, <iframe>, <video> or <a href>.
 * The backend `/api/upload/file/{id}` endpoint accepts the JWT via ?token= for these
 * browser elements that cannot send Authorization headers.
 */
export function getFileUrl(fileId, options = {}) {
  if (!fileId) return '';
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (options.download) params.set('download', 'true');
  const qs = params.toString();
  return `${base}/api/upload/file/${fileId}${qs ? `?${qs}` : ''}`;
}
